import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getTrustdockVerifications } from '@src/api'
import {
  DefaultApiGetTrustdockVerificationsRequest,
  GetTrustdockVerifications200Response,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchTrustdockVerifications = (
  params: DefaultApiGetTrustdockVerificationsRequest
) => {
  const { axiosInstance } = useAxios({
    // To redirect to `/public/create-account/signin` when a 401 error occurs.
    // Without specifying this, the user is automatically logged out and redirected to `/signin`.
    shouldSkipLogout: true,
  })

  return useQuery<
    AxiosResponse<GetTrustdockVerifications200Response>,
    AxiosResponse<CustomError>
  >({
    enabled: !!params.trustdockIdentificationId,
    queryFn: () => getTrustdockVerifications(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_TRUSTDOCK_VERIFICATIONS,
      params.trustdockIdentificationId,
    ],
    staleTime: 0,
  })
}
